import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { recentSearchClear } from '~data/actions/bookmarks'
import t from '~t'

import { Button, Section, SectionTitle, SectionActions, Icon } from '~ui';

export default function SearchMenuRecent() {
    const dispatch = useDispatch()
    const onClearClick = useCallback(()=>dispatch(recentSearchClear()), [])

    return (
        <Section className={'ui-recent-section'}>
            <SectionTitle>
                {t.s('recent')}
            </SectionTitle>

            <SectionActions>
                <Button
                    size='small'
                    variant='outline'
                    title={t.s('removeRecent')}
                    onClick={onClearClick}>
                    <Icon name='close' size='micro' />
                </Button>
            </SectionActions>
        </Section>
    )
}